import { render, staticRenderFns } from "./FaqsTabs.vue?vue&type=template&id=6b5c2bc2&scoped=true&"
import script from "./FaqsTabs.vue?vue&type=script&lang=js&"
export * from "./FaqsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5c2bc2",
  null
  
)

export default component.exports